function tel () {
    var phoneFormat = /^(\d{3})?(\d{3})(\d{4})$/;
    return function (input) {
        var parsed = phoneFormat.exec(input);
        return (!parsed) ? input : ((parsed[1]) ? '(' + parsed[1] + ') ' : '') + parsed[2] + '-' + parsed[3];
    };
}

angular.module('sentinel').filter('tel', tel);